import React from 'react';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiLink, FiArrowRight } = FiIcons;

export default function Home() {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center p-6 text-center">
      <div className="bg-blue-500 text-white p-4 rounded-2xl mb-6 shadow-lg">
        <SafeIcon icon={FiLink} size={48} />
      </div>
      
      <h1 className="text-5xl font-extrabold text-gray-900 mb-4 tracking-tight">
        One link for everything
      </h1>
      
      <p className="text-xl text-gray-600 mb-8 max-w-md">
        Share all your links, social profiles, and content in one beautiful, customizable page.
      </p>
      
      <div className="flex gap-4">
        <Link 
          to="/register" 
          className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-8 rounded-full flex items-center gap-2 transition-all transform hover:scale-105 shadow-md"
        >
          Get Started <SafeIcon icon={FiArrowRight} size={20} />
        </Link>
        
        <Link 
          to="/login" 
          className="bg-white hover:bg-gray-50 text-gray-900 font-semibold py-3 px-8 rounded-full border-2 border-gray-200 transition-all"
        >
          Sign In
        </Link>
      </div>
    </div>
  );
}